export const getters = {
  permissions: state => state.permissions,
  hasRole: state => role => state.permissions.some(p => p.funcao === role)
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/permission/getters.js